<app-protocolo-pesquisa
    [textoBotaoEnvio]="textoBotaoEnvio"
    [textoBotaoCadastro]="textoBotaoCadastro"
    [tooltipBotaoEnvio]="tooltipBotaoEnvio"
    [routerLinkEnvioLote]="['/integracao/scr/ipoc/envio']"
    [routerLinkCadastro]="['/integracao/scr/ipoc/cadastro']"
    [tiposConteudo]="tiposConteudo"
    [formatoArquivo]="'csv'"
    [mostrarCampoModoEnvio]=false
></app-protocolo-pesquisa>
